import { Availability } from "./availability.model";
import { Step1 } from "./cards";
import { Step2 } from "./step2";
import { Step3 } from "./step3";

export class Variables {

    public static get $(): any {
        return window['$'];
    }

    public static loadingDivId = "dvLoading";
    public static submittingDivId = "dvSubmittingForm";
    public static availabilitiesDivId = "dvAvailabilities";


}

const isDevMode: boolean = false;

// the function being used to fetch json files from API
export const getJsonDataFor = (fileName: string) => {
    return new Promise((resolve, reject) => {
        Variables.$.ajax({
            dataType: "json",
            url: `${isDevMode ? 'http://localhost:5000' : 'https://www.luxurychaletsmeribel.co.uk/api'}/public-files/${fileName}.json`,
        })
            .then((response) => {
                resolve(response);
            })
            .fail(() => {
                console.log(`failed to load ${fileName}`);
                Variables.$(`#${Variables.availabilitiesDivId}`).hide();
                Variables.$("#pErrorAvailabilities").show();
                reject();
            });
    });
};

export const dateToString = (date: Date, includeYear: boolean = true) => {
    let options: Intl.DateTimeFormatOptions = {
        day: "numeric"
    };
    options.month = "short";
    if (includeYear) {
        options.year = "numeric";
    }
    return date.toLocaleString("en-ie", options);
}

/**
 * Format Date object as YYYY-MM-DD without timezone conversion
 * Prevents date shifting when converting between timezones
 */
export const formatDateYYYYMMDD = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export const moneyToString = (money: number, includeFraction: boolean = false, currencySymbol = "€") => {
    if (money == null) {
        return "";
    }
    let options: Intl.NumberFormatOptions = {
    };
    if (includeFraction) {
        options.minimumFractionDigits = 2;
        options.maximumFractionDigits = 2;
    }
    return currencySymbol + money.toLocaleString(undefined, options);
}

export const scrollToTop = (elementId: string) => {
    Variables.$(window).scrollTop(Variables.$(`#${elementId}`).offset().top);
}



export const setStepQS = (stepName: 'step2' | 'step3' | null) => {

    //console.log('called set step method', stepName);

    const urlParams = new URLSearchParams(window.location.search);

    // if we are heading to the first step, i.e., cards
    if (stepName == null) {

        const currentStepName = urlParams.get('bookingStep');
        if (currentStepName) {
            urlParams.delete('bookingStep');

            const newUrl = new URL(window.location.href);
            newUrl.search = String(urlParams);
            window.history.replaceState({}, document.title, newUrl);
            window.onpopstate = () => {
                // If we don't do the following lines, the back button needs to pressed multiple time to work
                window.onpopstate = undefined;
                sessionStorage.removeItem('booking-state-pushed');

                // this is doing the back button
                window.history.back();
            }
        }

        return;
    }


    urlParams.set('bookingStep', stepName);

    const newUrl = new URL(window.location.href);
    newUrl.search = String(urlParams);

    if (sessionStorage.getItem('booking-state-pushed') === 'true') {
        window.history.replaceState({}, document.title, newUrl);
    } else {
        sessionStorage.setItem('booking-state-pushed', 'true');
        window.history.pushState({}, document.title, newUrl);
    }

    window.onpopstate = () => {
        onpopstate(stepName);
    };



}

// ========================================
// Prices Page Filter Functionality
// ========================================

export interface FilterState {
    showBooked: boolean;
    showCatered: boolean;
    showServiced: boolean;
}

const FILTER_STORAGE_KEY = 'pricesFilterState';
const CATERED_CHALETS = ['LesLoups', 'PetitePia', 'Phoebe', 'PiaChaletPlusApt', 'EtoileDesNeiges'];
const SERVICED_CHALETS = ['Galta', 'LesSolans', 'Alya'];

/**
 * Get the chalet type (catered or serviced) based on the accommodation name
 */
export const getChaletType = (accomName: string): 'catered' | 'serviced' | 'unknown' => {
    if (CATERED_CHALETS.includes(accomName)) {
        return 'catered';
    }
    if (SERVICED_CHALETS.includes(accomName)) {
        return 'serviced';
    }
    return 'unknown';
};

/**
 * Load filter state from localStorage or return defaults
 */
const loadFilterState = (): FilterState => {
    try {
        const stored = localStorage.getItem(FILTER_STORAGE_KEY);
        if (stored) {
            return JSON.parse(stored);
        }
    } catch (e) {
        console.warn('Failed to load filter state from localStorage', e);
    }
    // Default state: booked hidden, both types shown
    return {
        showBooked: false,
        showCatered: true,
        showServiced: true
    };
};

/**
 * Save filter state to localStorage
 */
const saveFilterState = (state: FilterState): void => {
    try {
        localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
        console.warn('Failed to save filter state to localStorage', e);
    }
};

/**
 * Apply the current filter state to all availability cards
 */
export const applyFilters = (state: FilterState): void => {
    const $ = Variables.$;
    const $cards = $('#pricesCardsContainer > div:not(#dvAvailabilityCardTemplate):not(#dvDividerTemplate):not(.divider)');
    let visibleCount = 0;
    const monthsWithVisibleCards = new Set<string>();

    $cards.each(function() {
        const $card = $(this);
        const isBooked = $card.hasClass('booked');
        const accomName = $card.attr('data-accom-name') || '';
        const chaletType = getChaletType(accomName);
        
        let shouldShow = true;

        // Filter by booked status
        if (isBooked && !state.showBooked) {
            shouldShow = false;
        }

        // Filter by chalet type
        if (chaletType === 'catered' && !state.showCatered) {
            shouldShow = false;
        }
        if (chaletType === 'serviced' && !state.showServiced) {
            shouldShow = false;
        }

        // Show or hide the card
        if (shouldShow) {
            $card.show();
            visibleCount++;
            
            // Track which months have visible cards
            const $prevDivider = $card.prevAll('.divider').first();
            if ($prevDivider.length) {
                const monthName = $prevDivider.attr('data-month-name');
                if (monthName) {
                    monthsWithVisibleCards.add(monthName);
                }
            }
        } else {
            $card.hide();
        }
    });

    // Show/hide month dividers based on whether they have visible cards
    $('#pricesCardsContainer > .divider:not(#dvDividerTemplate)').each(function() {
        const $divider = $(this);
        const monthName = $divider.attr('data-month-name');
        if (monthName && monthsWithVisibleCards.has(monthName)) {
            $divider.show();
        } else {
            $divider.hide();
        }
    });

    // Show/hide the "no results" message
    if (visibleCount === 0) {
        $('#noResultsMessage').show();
    } else {
        $('#noResultsMessage').hide();
    }
};

/**
 * Initialize the filter controls and bind event handlers
 */
export const initializeFilters = (): void => {
    const $ = Variables.$;
    const state = loadFilterState();

    // Set initial button states
    $('#filterShowBooked').toggleClass('active', state.showBooked);
    $('#filterShowCatered').toggleClass('active', state.showCatered);
    $('#filterShowServiced').toggleClass('active', state.showServiced);

    // Apply initial filter state
    applyFilters(state);

    // Bind click handlers
    $('.filter-btn').on('click', function() {
        const $btn = $(this);
        const filterType = $btn.attr('data-filter-type');
        
        // Toggle active state
        $btn.toggleClass('active');
        const isActive = $btn.hasClass('active');

        // Update state based on filter type
        if (filterType === 'booked') {
            state.showBooked = isActive;
        } else if (filterType === 'catered') {
            state.showCatered = isActive;
        } else if (filterType === 'serviced') {
            state.showServiced = isActive;
        }

        // Save and apply the new state
        saveFilterState(state);
        applyFilters(state);
    });
};

// ========================================
// End Prices Page Filter Functionality
// ========================================

const onpopstate = (callerState: 'step2' | 'step3' | null) => {

    // when the sub,it button is clicked, this pop state is called as well,
    // while we want to do all stuff below only if the BROWSER BACK button is clicked
    if (Step3.instance.submitButtonPoppingState) {
        Step3.instance.submitButtonPoppingState = false;
        return;
    }

    window.onpopstate = () => {
        window.onpopstate = undefined;
        sessionStorage.removeItem('booking-state-pushed');
        window.history.back();
    }

    // If the user clicks on the BROWSER BACK button, we reload the page. That basically leads to the first step, i.e., cards.
    setTimeout(() => {
        window.location.reload();
    }, 1);

    return;
    // //const urlParams = new URLSearchParams(window.location.search);

    // // const targetStepName = urlParams.get('bookingStep');
    // console.log(callerState);
    // // console.log(window.location.search);
    // sessionStorage.removeItem('booking-state-pushed');
    // switch (callerState) {
    //     case 'step2':
    //         Step2.instance.clickStartOverButton();
    //         window.onpopstate = () => {
    //             window.onpopstate = undefined;
    //             //window.history.back();
    //         }
    //         return;
    //     case 'step3':
    //         Step3.instance.clickBackButton();
    //         break;
    //     default:
    //         break;
    // }
    // window.onpopstate = undefined;

}
